export default {"src":"/_next/static/media/header-backgrund-test.8d73886b.gif","height":300,"width":1600,"blurWidth":0,"blurHeight":0};